import "venuescanner-js/react/components/VenueSearch/styles/globalStyles.scss";
import "./styles.scss";
